// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--IAJ0H","rate":"_02712f2b3b--rate--e82rF"};